<template>
    <buttons-text :label="label" :color="color" @clicked="$emit('clicked', $event)" :small="small">
        <template v-slot:icon-left v-if="iconLeft">
            <v-icon :small="small">{{ icon }}</v-icon>
        </template>
        <template v-slot:icon-right v-if="iconRight">
            <v-icon :small="small">{{ icon }}</v-icon>
        </template>
    </buttons-text>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

const emit = defineEmits(['clicked'])

const props = defineProps({
    label: { type: String, required: true },
    color: { type: String, default: 'primary' },
    icon: { type: String, default: 'mdi-plus' },
    iconLeft: { type: Boolean, default: false },
    iconRight: { type: Boolean, default: false },
    small: { type: Boolean, default: false },
})

</script>